import type { FC } from 'react';
import React from 'react';
import { Box } from '@withjoy/joykit';
import { findAspectRatioFromPercentCrop } from '@shared/utils/findAspectRatioFromPercentCrop';
import type { MarqueePhotoRendererProps } from './PhotoMarquee.types';

export const MarqueePhoto: FC<MarqueePhotoRendererProps> = props => {
  const { photo, index, containerDimensions, photoRenderer: PhotoRenderer } = props;
  const aspectRatio = photo.cropInfo ? findAspectRatioFromPercentCrop(photo.cropInfo, photo.width, photo.height) : photo.width / photo.height;
  const photoWidth = containerDimensions.height * aspectRatio;

  return (
    <Box
      key={`${photo.id}-${index}`}
      // CSS-derived width (height × photo AR): the AR is known synchronously from cropInfo, so the
      // tile is sized in the SSR HTML. The old JS width (ResizeObserver height × AR) was 0 until
      // the first client measure — the whole marquee row rendered empty, then populated.
      aspectRatio={`${aspectRatio}`}
      flexShrink={0}
      height="100%"
    >
      <PhotoRenderer
        photoUrl={photo.photoUrl}
        cropInfo={photo.cropInfo ? { ...photo.cropInfo, unit: '%' } : null}
        width={photoWidth}
        height={containerDimensions.height}
        containerType="fixed-aspect"
      />
    </Box>
  );
};
